/**
 * Sum a named map field across an array of daily rollup docs.
 * Returns `{ key: total }` aggregated across all days.
 */
export function sumMapsAcrossDays(dailyDocs, fieldName) {
    const out = {};
    for (const d of dailyDocs || []) {
        const m = d[fieldName] || {};
        for (const [k, v] of Object.entries(m)) {
            out[k] = (out[k] || 0) + (v || 0);
        }
    }
    return out;
}
